/**
 * Los botones estándar del pie de un modal.
 *
 * Viven acá y no en `Modal.tsx` porque **no son del Modal**: son dos botones con
 * una etiqueta y una variante fijadas, y el `Modal` del repo está en camino de
 * desaparecer a favor del de `components/ds/`. Dejarlos donde estaban obligaba a
 * cada pantalla migrada a importar dos cosas que se llaman casi igual desde dos
 * archivos distintos.
 *
 * ⚠️ El pie del `Modal` del design system se llama `actions`, no `footer`.
 */
import { Button } from './Button'

export function ModalCancelButton({ onClick, label = 'Cancelar' }: { onClick: () => void; label?: string }) {
  return <Button type="button" variant="secondary" onClick={onClick}>{label}</Button>
}

export function ModalSubmitButton({ isPending, label, variant = 'primary' }: {
  isPending?: boolean; label: string; variant?: 'primary' | 'danger' | 'success'
}) {
  return <Button type="submit" variant={variant} size="lg" isPending={isPending}>{label}</Button>
}
